import type { WatchSource } from "vue";
import { onUnmounted, watch } from "vue";

/**
 * Keeps an event subscription open only while `isNeeded` holds: `open` runs when it turns true and the
 * returned handle is closed when it turns false or the owner unmounts.
 */
export function useLazyEvents(isNeeded: WatchSource<boolean>, open: () => { close: () => void }) {
  let handle: { close: () => void } | undefined;

  function close() {
    handle?.close();
    handle = undefined;
  }

  watch(
    isNeeded,
    (needed) => {
      if (needed && !handle) handle = open();
      else if (!needed) close();
    },
    { immediate: true },
  );

  onUnmounted(close);
}
